import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupEditComponent } from './group-edit.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { SharedModule } from '../../shared/shared.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { GroupEditCodingDocumentComponent } from './group-edit-coding-document/group-edit-coding-document.component';

@NgModule({
  declarations: [GroupEditComponent, GroupEditCodingDocumentComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule
  ]
})
export class GroupEditModule { }
